export default __webpack_public_path__ + "static/media/251064.095664ee.webp";